export type Integration = {
  slug: string
  name: string
  description: string
  icon?: string
  active: boolean
  connectedStores: number
  unconnectedStores: number
  to?: string
  // Custom webhooks have no connect/OAuth flow, so their inactive state
  // needs a different label than the partner default ("Connect").
  inactiveActionLabel?: string
}

export enum IntegrationStatus {
  ACTIVE = 'ACTIVE'
}

type IntegrationStore = {
  id: string
  name: string
}

export type FetchedIntegration = {
  type: string
  status: IntegrationStatus
  category: string[]
  stores: {
    connected: IntegrationStore[]
    notConnected: IntegrationStore[]
  }
}
